module.exports = __webpack_public_path__ + "static/p-arin-37f12776276711706af0aeac70366c9a.jpg";